import { ItemInventario } from './../item-inventario/item-inventario.model';
import { ListaResultset } from './../../../core/list/lista-resultset.interface';
import { InventarioFilter, Inventario } from './../inventario/inventario.model';
import { ButtonType } from './../../../core/enums/buttontype.enum';
import { Lista } from '../../../core/list/lista.model';
import { ILoteFilter } from './../lote/lote.model';
import { DataType } from './../../../core/enums/datatype.enum';
import { Align } from './../../../core/enums/align.enum';
import { StatusRetirada } from './../../../core/enums/status-retirada.enum';
import { InventarioService } from '../inventario/inventario.service';
import { ItemInventarioService } from '../item-inventario/item-inventario.service';
import { ListHandlerService } from './../../../core/list/list-handler.service';
import { Metadata } from './../../../core/list/metadata/metadata.component';
import { RetiradaComponent } from './retirada.component';
import { ListaComponent } from './../../../core/list/lista.component';
import { ListaUtil } from './../../../core/list/lista-util';
import { IItemProdutoRetirada } from '../item-produto-retirada/item-produto-retirada.model';
import { IInventarioLotePK } from './model/inventarioLotePk.interface';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { IItemInventarioRetirada } from './model/item-inventario-retirada.interface';
import { Unidade } from '../../unidade/unidade.model';
import { BaixaDeProdutoListaSelecaoMetadata } from '../baixa-de-produto-v2/model/baixa-de-produto-lista-selecao.metadata';

export class ItemRetiradaMetadata {

  static passarDescricaoDoLoteNullParaStringVazia(content: any[]): any {
    if ( !content || content.length <= 0 ) {
      return content;
    }

    const _content = Object.assign([], content);
    _content.forEach(item => {
      if ( item.lote && !item.lote.descricao ) {
        item.lote.descricao = 'sem_lote';
      }
    });

    return _content;
  }

  static filhosLoteTemplate: Metadata[] = [
    {
      fieldId: 'id',
      fieldName: 'Id',
      align: Align.LEFT
    }
    , {
        fieldId: 'descricao',
        fieldName: 'Lote',
        align: Align.LEFT,
        podeNaoExistir: true
    }
    , {
        fieldId: 'dataVencimento',
        fieldName: 'Vencimento',
        align: Align.LEFT,
        dataType: DataType.DATE
    }
  ];

    getMetadata(retiradaComponent: RetiradaComponent
                , usuarioService: UsuarioService
                , statusRetirada: StatusRetirada
                , inventarioService: InventarioService
                , itemInventarioService: ItemInventarioService
                , listHandlerService: ListHandlerService
                , listaComponent: ListaComponent
                , unidade: Unidade
                , isPreparandoBaixa: boolean
                ): Metadata[] {

        const _usuarioTemPermissaoRetiradaParcial = usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_EFETUAR_RETIRADA_PARCIAL);
        const _isUsuarioSolicitante = false;
        let _exibirColunasInventarioELote = false;
        let _isQuantidadeEditavel  = false;
        let _exibirColunaExcluir = false;
        let _exibirColunaPopUpInventarioELote = false;

        let _fnExcluirDesabilitado = !_usuarioTemPermissaoRetiradaParcial;
        let _editarQuantidadeDesabilitado = !_usuarioTemPermissaoRetiradaParcial;


        switch ( statusRetirada ) {
          case StatusRetirada.APROVADA:
            _isQuantidadeEditavel = false;
            _exibirColunaExcluir = true;
            _exibirColunasInventarioELote = !_isUsuarioSolicitante;
            _exibirColunaPopUpInventarioELote = !_isUsuarioSolicitante;
            break;

          case StatusRetirada.SOLICITADA:
            _isQuantidadeEditavel = false;
            _exibirColunaExcluir = true;
            _fnExcluirDesabilitado = false;
            _editarQuantidadeDesabilitado = false;
            break;

          case StatusRetirada.RETIRADA:
          case StatusRetirada.BAIXADA:
            _exibirColunasInventarioELote = true;
            break;

          case StatusRetirada.REPROVADA:
          case StatusRetirada.CANCELADA:
            break;

          default:
            // NOVA SOLICITACAO ( ainda sem status )
            _isQuantidadeEditavel = true;
            _exibirColunaExcluir = true;
            _fnExcluirDesabilitado = false;
            _editarQuantidadeDesabilitado = false;

            if ( isPreparandoBaixa ) {
              _exibirColunasInventarioELote = true;
              _exibirColunaPopUpInventarioELote = true;
            }
            break;
        }

        let metadata: Metadata[];

        let _fieldIdTipoProduto;
        let _fieldIdDescricaoProduto;
        let _fieldIdTussProduto;
        let _fieldIdQuantidadeProduto;
        let _fieldIdInventario;
        let _fieldIdLote;

        let _filhosInventario;
        let _filhosLote;

        // FIXME: remover bloco abaixo
        if ( false && statusRetirada === StatusRetirada.RETIRADA ) {
          _fieldIdTipoProduto = 'itemInventarioRetiradaPK.itemInventario.lote.produto.tipo';
          _fieldIdDescricaoProduto = 'itemInventarioRetiradaPK.itemInventario.lote.produto.descricao';
          _fieldIdTussProduto = 'itemInventarioRetiradaPK.itemInventario.lote.produto.tuss';
          _fieldIdQuantidadeProduto = 'quantidadeRetirada';
          _fieldIdInventario = 'itemInventarioRetiradaPK.itemInventario.inventario';
          _fieldIdLote = 'itemInventarioRetiradaPK.itemInventario.lote';

          _filhosInventario = [
            {fieldId: 'id', fieldName: 'Id', align: Align.LEFT}
            , {fieldId: 'nome', fieldName: 'Nome', align: Align.LEFT}
          ];

          _filhosLote = ItemRetiradaMetadata.filhosLoteTemplate;
        }
        else {
          _fieldIdTipoProduto = 'itemProdutoRetiradaPK.produto.tipo';
          _fieldIdDescricaoProduto = 'itemProdutoRetiradaPK.produto.descricao';
          _fieldIdTussProduto = 'itemProdutoRetiradaPK.produto.tuss';
          _fieldIdQuantidadeProduto = 'quantidade';
          _fieldIdInventario = 'inventario';
          _fieldIdLote = 'lote';

          _filhosInventario = [
              {fieldId: 'id', fieldName: 'Id', align: Align.LEFT}
            , {fieldId: 'nome', fieldName: 'Nome', align: Align.LEFT}
          ];

          _filhosLote = ItemRetiradaMetadata.filhosLoteTemplate;
        }

        metadata = [
            {
              fieldId: '',
              fieldName: 'Local',
              dataType: DataType.HTML,
              fnValorCelula: (data => {
                const possuiInventario = !!data.inventario;
                return BaixaDeProdutoListaSelecaoMetadata.getLocalHtml(possuiInventario ? 'I' : 'E');
              })
            }
            , {
                fieldId: _fieldIdTipoProduto,
                fieldName: 'Tipo'
            }
            , {
                fieldId: _fieldIdDescricaoProduto,
                fieldName: 'Descrição'
            }
            , {
                fieldId: _fieldIdTussProduto,
                fieldName: 'TUSS'
            }
            , {
                fieldId: _fieldIdQuantidadeProduto,
                fieldName: 'Quant.',
                align: Align.RIGHT,
                editable: _isQuantidadeEditavel,
                disabled: _editarQuantidadeDesabilitado,
                dataType: DataType.NUMBER,
                fnClick: function(event: any, data: any, rowIndex: number, lista: Lista, listHandlerService: ListHandlerService) {
                  if ( !_isQuantidadeEditavel ) {
                    return;
                  }

                  const target = event.target || event.srcElement || event.currentTarget;
                  const idAttr = target.attributes.id;
                  const inputId = idAttr.nodeValue;
                  const row = lista.resultset.content[rowIndex];

                  listaComponent.poi.show(event, inputId, data.quantidade)
                                    .subscribe(novaQuantidade => {
                                      row.quantidade = novaQuantidade;

                                      listHandlerService.refreshList({
                                        filtro: null
                                        , lista
                                      });
                                    });
              }
            }
        ];


        if (_exibirColunasInventarioELote) {
            metadata = metadata.concat(
                [
                  {
                    fieldId: 'idItemInventario',
                    fieldName: 'Id Item Setor',
                    align: Align.LEFT,
                    dataType: DataType.NUMBER,
                    hidden: true,
                    podeNaoExistir: true
                  },
                  {
                    fieldId: _fieldIdInventario,
                    fieldName: 'Setor',
                    align: Align.LEFT,
                    dataType: DataType.OBJECT,
                    filhos: _filhosInventario,
                    editable: ( statusRetirada !== StatusRetirada.RETIRADA && statusRetirada !== StatusRetirada.BAIXADA ),
                    fnClick: function(event: any, data: any, rowIndex: number, lista: Lista, pListHandlerService: ListHandlerService) {
                        const target = event.target || event.srcElement || event.currentTarget;
                        const idAttr = target.attributes.id;
                        const inputId = idAttr.nodeValue;
                        const row = lista.resultset.content[rowIndex];

                        const _inventarioFilter: InventarioFilter = {
                            status: 'A'
                            , idProduto: data.itemProdutoRetiradaPK.produto.id
                            , idUnidade: ( unidade ? unidade.id : null )
                        };

                        inventarioService.listar(_inventarioFilter)
                        .subscribe((response: ListaResultset<Inventario>) => {
                            retiradaComponent.poddl.show(event,
                                                         response.content,
                                                         [{propriedade: 'id'}, {propriedade: 'nome'}],
                                                         inputId,
                                                         '',
                                                         'Selecione setor')
                            .subscribe(inventario => {
                                row.inventario = inventario;

                                // limpar seleção do lote
                                row.idItemInventario = null;
                                row.lote = null;

                                pListHandlerService.refreshList({
                                    filtro: null
                                    , lista
                                });

                                // automatizar a seleção do lote ( caso o produto exista em apenas 1 lote )
                                const _loteFilter: ILoteFilter = {
                                  status: 'A'
                                  , idInventario: inventario.id
                                  , idProduto: data.itemProdutoRetiradaPK.produto.id
                                };
                                itemInventarioService.list(inventario.id, _loteFilter)
                                                      .subscribe((itensInventarioResponse: ListaResultset<ItemInventario>) => {
                                                        const itensInventario = itensInventarioResponse.content;

                                                        if (itensInventario.length === 1 && itensInventario[0].lote) {
                                                            row.idItemInventario = itensInventario[0].id;
                                                            row.lote = itensInventario[0].lote;
                                                        }
                                                        pListHandlerService.refreshList({
                                                            filtro: null
                                                            , lista
                                                        });
                                                    });
                            });
                        });
                    }
                  }

                  , {
                      fieldId: _fieldIdLote,
                      fieldName: 'Lote',
                      align: Align.LEFT,
                      dataType: DataType.OBJECT,
                      filhos: _filhosLote,
                      editable: ( statusRetirada !== StatusRetirada.RETIRADA && statusRetirada !== StatusRetirada.BAIXADA ),
                      fnClick: function(event: any, data: any, rowIndex: number, lista: Lista, pListHandlerService: ListHandlerService) {
                        const target = event.target || event.srcElement || event.currentTarget;
                        const idAttr = target.attributes.id;
                        const inputId = idAttr.nodeValue;
                        const row = lista.resultset.content[rowIndex];

                        // recuperar o setor selecionado da lista
                        let _idInventario: number;
                        if (row.inventario) {
                            _idInventario = row.inventario.id;
                        }
                        else {
                          retiradaComponent.toasterService.info('Selecione o setor');
                          return;
                        }

                        const _loteFilter: ILoteFilter = {
                            status: 'A'
                            , idInventario: _idInventario
                            , idProduto: data.itemProdutoRetiradaPK.produto.id
                        };

                        itemInventarioService.list(_idInventario, _loteFilter)
                          .subscribe((response: ListaResultset<any>) => {

                            const _content = ItemRetiradaMetadata.passarDescricaoDoLoteNullParaStringVazia(response.content);

                            retiradaComponent.poddl.show(event,
                                                          _content,
                                                         [{
                                                            propriedade: 'lote.id'},
                                                          {
                                                            propriedade: 'lote.descricao'
                                                          },
                                                          {
                                                            propriedade: 'lote.dataVencimento'
                                                           , dataType: DataType.DATE
                                                          }]
                                                         , inputId
                                                         , ''
                                                         , 'Selecione lote')
                                         .subscribe(itemInventario => {
                                            row.idItemInventario = itemInventario.id;
                                            row.lote = itemInventario.lote;
                                            pListHandlerService.refreshList({
                                                filtro: null
                                                , lista
                                            });
                                          });
                        });
                      }
                  }

                  , {
                      fieldId: 'idItemInventario'
                      , podeNaoExistir: true
                      , hidden: true
                      , align: Align.CENTER
                  }
                ]
            );
         }

        if (_exibirColunaPopUpInventarioELote) {
            metadata = metadata.concat([{
              fieldId: '',
              title: 'Abrir popup...',
              align: Align.CENTER,
              dataType: DataType.BUTTON,
              buttonType: ButtonType.POPUP,
              fnClick: function(event: any, data: IItemProdutoRetirada, rowIndex: number, lista: Lista, pListHandlerService: ListHandlerService) {
                const row = ListaUtil.getRowByIndex(rowIndex, lista);

                retiradaComponent.abrirPopupDetalheRetirada(event, data, lista.resultset.content)
                                .subscribe( (inventariosDTOSelecionados: IItemInventarioRetirada[]) => {
                                    ItemRetiradaMetadata.atualizarTabelaComRetornoDoPopup(pListHandlerService
                                                                          , lista
                                                                          , row
                                                                          , inventariosDTOSelecionados);
                                });

              }}]
            );
        }

       if (_exibirColunaExcluir) {
          metadata = metadata.concat(
            {
              fieldId: '',
              title: 'Excluir produto...',
              align: Align.CENTER,
              dataType: DataType.BUTTON,
              buttonType: ButtonType.EXCLUIR,
              disabled: _fnExcluirDesabilitado,
              fnClick: function(event: any, data: any, rowIndex: number, lista: Lista) {
                retiradaComponent.confirmacaoService.confirmarExclusao(() => {
                  lista.resultset.content.splice(rowIndex, 1);
                  retiradaComponent.unidadeBloqueada = lista.resultset.content.length > 0;
                });
              }
            }
          );
        }

        return metadata;
    }

    static getInventarioELotePelaPK(pk: IInventarioLotePK, iirSelecionados: IItemInventarioRetirada[]): IItemInventarioRetirada {
      for ( let iir of iirSelecionados ) {
        if ( (pk.idInventario === iir.inventario.id) && (pk.idLote === iir.lote.id) ) {
          return iir;
        }
      }

      return null;
    }

    static getLinhaComInventarioELoteIndefinido(filtroIdProduto: number, lista: Lista): any {
      const rows = ListaUtil.getRows(lista);

      for ( let o of rows ) {
        if ( filtroIdProduto === o.itemProdutoRetiradaPK.produto.id
             && !o.inventario
             && !o.lote ) {

              return o;
             }
      }

      return null;
    }

    static getLinhaPorInventarioELote(filtroIdProduto: number, filtroIdInventario: number, filtroIdLote, lista: Lista): any {
      const rows = ListaUtil.getRows(lista);

      for ( let o of rows ) {
        if ( filtroIdProduto === o.itemProdutoRetiradaPK.produto.id
             && o.inventario.id === filtroIdInventario
             && o.lote.id === filtroIdLote ) {

              return o;
             }
      }

      return null;
    }

    static atualizarTabelaComRetornoDoPopup(listHandlerService: ListHandlerService
                                            , lista: Lista
                                            , linha: any
                                            , iirSelecionados: IItemInventarioRetirada[]) {

      if ( !iirSelecionados || iirSelecionados.length === 0 ) {
        return;
      }

      const currentRowIdProduto = linha.itemProdutoRetiradaPK.produto.id;
      if ( iirSelecionados.length === 1 ) {
        // apenas um inventario e um lote selecionado
        linha.inventario = iirSelecionados[0].inventario;
        linha.lote = iirSelecionados[0].lote;
        linha.quantidade = iirSelecionados[0].quantidadeRetirada;
        linha.idItemInventario = iirSelecionados[0].itemInventario.id;
      }
      else {
        // mais de um inventario e/ou lote selecionados
        const noLinhasTabela = lista.resultset.content.length;

        const lotesDaTabelaPrincipalPK: IInventarioLotePK[] = [];
        const lotesSelecionadosPK: IInventarioLotePK[] = [];

        const lotesSelecionadosQueNaoExistemNaTabelaPrincipalPK: IInventarioLotePK[] = [];
        const lotesSelecionadosQueExistemNaTabelaPrincipalPK: IInventarioLotePK[] = [];



        // mapear lotes selecionados no popup
        for ( let iir of iirSelecionados ) {
          lotesSelecionadosPK.push({
            idInventario: iir.inventario.id,
            idLote: iir.lote.id
          });
        }



        // mapear lotes que já estavam definidos na tabela ( filtrando sempre pelo produto )
        for ( let i = 0; i < noLinhasTabela ; i++ ) {
          const row = ListaUtil.getRowByIndex(i, lista);
          const rowIdProduto = row.itemProdutoRetiradaPK.produto.id;
          if ( rowIdProduto !== currentRowIdProduto ) {
            continue;
          }

          if ( row.inventario && row.lote ) {
            lotesDaTabelaPrincipalPK.push({
              idInventario: row.inventario.id,
              idLote: row.lote.id
            });
          }
        }



        // mapear lotes selecionados que nao existam na tabela principal
        for ( let oPK of lotesSelecionadosPK ) {
          if ( lotesDaTabelaPrincipalPK.find(o => JSON.stringify(o) === JSON.stringify(oPK)) ) {
            lotesSelecionadosQueExistemNaTabelaPrincipalPK.push(oPK);
          }
          else {
            lotesSelecionadosQueNaoExistemNaTabelaPrincipalPK.push(oPK);
          }
        }



        // criar lote/inventario que nao existam na tabela principal
        for ( let oPK of lotesSelecionadosQueNaoExistemNaTabelaPrincipalPK ) {

          const iirACriar = ItemRetiradaMetadata.getInventarioELotePelaPK(oPK, iirSelecionados);
          if ( !iirACriar ) {
            continue;
          }

          // se existir slot vazio, usar a linha ( slot vazio = uma linha do Produto corrente, com setor e lote não definido )
          const rowEmptySlot = ItemRetiradaMetadata.getLinhaComInventarioELoteIndefinido(currentRowIdProduto, lista);
          if ( rowEmptySlot ) {
            rowEmptySlot.inventario = iirACriar.inventario;
            rowEmptySlot.lote = iirACriar.lote;
            rowEmptySlot.quantidade = iirACriar.quantidadeRetirada;
            rowEmptySlot.idItemInventario = iirACriar.itemInventario.id;
          }
          else {
            const newRow: IItemProdutoRetirada = {
              itemProdutoRetiradaPK: linha.itemProdutoRetiradaPK,
              inventario: iirACriar.inventario,
              lote: iirACriar.lote,
              quantidade: iirACriar.quantidadeRetirada
            };
            newRow['idItemInventario'] = iirACriar.itemInventario.id;

            lista = ListaUtil.incluir(newRow, lista);
          }
        }



        // atualizar lote/inventario que ja existam na tabela principal ( que estão com inventario e lote definido )
        for ( let oPK of lotesSelecionadosQueExistemNaTabelaPrincipalPK ) {

          const iirACriar = ItemRetiradaMetadata.getInventarioELotePelaPK(oPK, iirSelecionados);
          if ( !iirACriar ) {
            continue;
          }

          const rowUpdate = ItemRetiradaMetadata.getLinhaPorInventarioELote(currentRowIdProduto, oPK.idInventario, oPK.idLote, lista);
          if ( rowUpdate ) {
            rowUpdate.inventario = iirACriar.inventario;
            rowUpdate.lote = iirACriar.lote;
            rowUpdate.quantidade = iirACriar.quantidadeRetirada;
          }
        }
      }

      listHandlerService.refreshList({
        filtro: null
        , lista
      });

    }
}
